import { Divider, Typography } from '@mui/material'
import React from 'react'

function AdjustPriceBlock() {
    return (
        <Typography variant='body1'>
            Vid eventuella nyemissioner innan teckningsperiodens start ska teckningskursen justeras till
            emissionskursen.
        </Typography>
    )
}

function ExternalCommentBlock({ warrant }) {
    return warrant.externalComment ? (
        <div style={{ whiteSpace: 'pre-line' }}>
            <Typography variant='body1'>{warrant.externalComment}</Typography>
        </div>
    ) : null
}

export const warrantOtherInfoHasContent = (warrant, sources) => {
    return (warrant.externalComment || warrant.issuesAdjustPrice || sources.length > 0) ?? false
}

const WarrantOtherInfo = ({ warrant }) => {
    return (
        <>
            <ExternalCommentBlock warrant={warrant} />
            {warrant.issuesAdjustPrice ? (
                <>
                    {warrant.externalComment?.length > 0 && <Divider sx={{ my: 3 }} />}
                    <AdjustPriceBlock />
                </>
            ) : null}
        </>
    )
}

export default WarrantOtherInfo
